/**
 * Application entry point.
 *
 * Sets up providers:
 * - MSAL for Microsoft authentication
 * - Teams SSO for Microsoft Teams integration
 * - Apollo for GraphQL
 * - React Router for navigation
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { msalInstance } from './lib/msal-config'
import { apolloClient } from './lib/apollo-client'
import { TeamsAuthProvider } from './components/providers/TeamsAuthProvider'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <TeamsAuthProvider>
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </TeamsAuthProvider>
    </MsalProvider>
  </React.StrictMode>,
)
